function base64UrlEncode(buf: ArrayBuffer): string {
  return btoa(String.fromCharCode(...Array.from(new Uint8Array(buf))))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

function encodeJson(obj: object): string {
  return base64UrlEncode(
    new TextEncoder().encode(JSON.stringify(obj)).buffer as ArrayBuffer,
  );
}

export async function generateFunnelAuthJwt(): Promise<string> {
  const secret = process.env.REACT_APP_FUNNEL_AUTH_JWT_SECRET || '';
  const now = Math.floor(Date.now() / 1000);

  const header = encodeJson({ alg: 'HS256', typ: 'JWT' });
  const payload = encodeJson({
    service_name: 'enph-app',
    iat: now,
    exp: now + 300,
  });
  const signingInput = `${header}.${payload}`;

  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    new TextEncoder().encode(secret),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign'],
  );

  const signature = await crypto.subtle.sign(
    'HMAC',
    cryptoKey,
    new TextEncoder().encode(signingInput),
  );

  return `${signingInput}.${base64UrlEncode(signature)}`;
}
